@if (loading$ | async) {
  <div class="loading-state">
    <nb-spinner></nb-spinner>
  </div>
}

@if (!(loading$ | async)) {
  @if (sections().length > 0) {
    <div class="fields-toolbar">
      <button nbButton ghost size="small" nbTooltip="Alle ausklappen" (click)="expandAll()">
        <nb-icon icon="expand-outline" pack="eva"></nb-icon>
      </button>
      <button nbButton ghost size="small" nbTooltip="Alle einklappen" (click)="collapseAll()">
        <nb-icon icon="collapse-outline" pack="eva"></nb-icon>
      </button>
    </div>
  }

  <div class="sections">
    @for (section of sections(); track section.collectionDetail.id; let i = $index) {
      <div class="section-card">
        <div class="section-header" (click)="toggleExpand(i)"
             [style.background]="getHeaderBg(section.collectionDetail.color)">
          <div class="section-header-left">
            <span class="section-title">{{ section.collectionDetail.title }}</span>
            @if (section.existingInstance?.collection?.deleted) {
              <nb-icon icon="alert-triangle-outline" pack="eva" status="warning"
                       nbTooltip="Diese Feldgruppe wurde gelöscht" nbTooltipStatus="warning"></nb-icon>
            }
          </div>
          <nb-icon [icon]="section.expanded ? 'chevron-up-outline' : 'chevron-down-outline'" pack="eva"></nb-icon>
        </div>
        <div class="section-body" [hidden]="!section.expanded">
          @if (section.collectionDetail.description) {
            <p class="description">
              {{ section.collectionDetail.description }}
            </p>
          }
          <wr-custom-form
            [collection]="section.collectionDetail"
            [instance]="section.existingInstance"
            [readonly]="!isEditing()">
          </wr-custom-form>
        </div>
      </div>
    }

    @if (sections().length === 0) {
      <div class="empty-state">
        <nb-icon icon="layers-outline" pack="eva"></nb-icon>
        <span>Dieser TGA-Typ hat keine benutzerdefinierten Feldgruppen.</span>
      </div>
    }
  </div>
}
